// extracted by mini-css-extract-plugin
export default {"button":"_2jzpO dim-button","badge":"SYC6q"};